import { UserMenuComponent } from "./userMenu";

export const UserMenu = UserMenuComponent;
